// Liste des bons de commande.
import React, { useEffect, useState } from 'react';
import {
  Alert, Box, Button, Card, Chip, LinearProgress, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField,
} from '@mui/material';
import { AddOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import { useAuth } from '../../context/AuthContext';
import { achatsAPI } from '../../services/api';
import { apiError, dateFr, fcfa } from '../../utils/format';
import { BC_STATUS } from './status';
import { tokens } from '../../theme';

const BonsCommande = () => {
  const navigate = useNavigate();
  const { canAchats } = useAuth();
  const [rows, setRows] = useState([]);
  const [fournisseurs, setFournisseurs] = useState([]);
  const [filters, setFilters] = useState({ statut: '', fournisseur_id: '' });
  const [error, setError] = useState('');

  useEffect(() => { achatsAPI.fournisseurs(true).then((r) => setFournisseurs(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const params = Object.fromEntries(Object.entries(filters).filter(([, v]) => v));
    achatsAPI.commandes(params).then((r) => setRows(r.data)).catch((e) => setError(apiError(e)));
  }, [filters]);

  const enCours = rows.filter((r) => ['ENVOYE', 'PARTIEL'].includes(r.statut));
  return (
    <Layout title="Bons de commande" plain
      actions={canAchats && <Button variant="contained" startIcon={<AddOutlined />} onClick={() => navigate('/achats/commandes/nouveau')}>Nouvelle commande</Button>}>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap', alignItems: 'center' }}>
        <TextField select size="small" label="Statut" value={filters.statut} sx={{ minWidth: 200 }} onChange={(e) => setFilters({ ...filters, statut: e.target.value })}>
          <MenuItem value="">Tous</MenuItem>
          <MenuItem value="ENVOYE,PARTIEL">En attente de livraison</MenuItem>
          {Object.entries(BC_STATUS).map(([k, v]) => <MenuItem key={k} value={k}>{v.label}</MenuItem>)}
        </TextField>
        <TextField select size="small" label="Fournisseur" value={filters.fournisseur_id} sx={{ minWidth: 220 }} onChange={(e) => setFilters({ ...filters, fournisseur_id: e.target.value })}>
          <MenuItem value="">Tous</MenuItem>
          {fournisseurs.map((f) => <MenuItem key={f.id} value={f.id}>{f.nom}</MenuItem>)}
        </TextField>
        <Box sx={{ ml: 'auto', fontSize: 14, color: 'text.secondary' }}>
          {enCours.length} commande(s) en attente de livraison · {fcfa(enCours.reduce((s, r) => s + r.total_ttc, 0))} F TTC
        </Box>
      </Box>
      <Card variant="outlined">
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Numéro</TableCell><TableCell>Date</TableCell><TableCell>Fournisseur</TableCell><TableCell>Livraison prévue</TableCell>
                <TableCell align="right">Total TTC</TableCell><TableCell sx={{ width: 140 }}>Réception</TableCell><TableCell align="right">Facturé</TableCell><TableCell>Statut</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => {
                const late = ['ENVOYE', 'PARTIEL'].includes(r.statut) && r.date_livraison_prevue && r.date_livraison_prevue < new Date().toISOString().slice(0, 10);
                return (
                  <TableRow key={r.id} hover sx={{ cursor: 'pointer' }} onClick={() => navigate(`/achats/commandes/${r.id}`)}>
                    <TableCell sx={{ fontFamily: tokens.mono, fontWeight: 600, whiteSpace: 'nowrap' }}>{r.numero || '—'}</TableCell>
                    <TableCell>{dateFr(r.date_commande)}</TableCell>
                    <TableCell>{r.fournisseur}</TableCell>
                    <TableCell sx={{ color: late ? 'error.main' : undefined }}>{r.date_livraison_prevue ? dateFr(r.date_livraison_prevue) : ''}{late ? ' (en retard)' : ''}</TableCell>
                    <TableCell align="right" sx={{ fontFamily: tokens.mono, whiteSpace: 'nowrap' }}>{fcfa(r.total_ttc)}</TableCell>
                    <TableCell>
                      {r.statut !== 'BROUILLON' && r.statut !== 'ANNULE' && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <LinearProgress variant="determinate" value={Math.min(100, (r.taux_reception || 0) * 100)} sx={{ flex: 1, height: 6, borderRadius: 3 }} />
                          <Box sx={{ fontSize: 12, fontFamily: tokens.mono }}>{Math.round((r.taux_reception || 0) * 100)}%</Box>
                        </Box>
                      )}
                    </TableCell>
                    <TableCell align="right" sx={{ fontFamily: tokens.mono, whiteSpace: 'nowrap' }}>{r.total_facture ? fcfa(r.total_facture) : ''}</TableCell>
                    <TableCell><Chip size="small" label={BC_STATUS[r.statut].label} color={BC_STATUS[r.statut].color} /></TableCell>
                  </TableRow>
                );
              })}
              {rows.length === 0 && <TableRow><TableCell colSpan={8} align="center" sx={{ py: 3 }}>Aucun bon de commande</TableCell></TableRow>}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Layout>
  );
};

export default BonsCommande;
